var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"carrusels fullscreen-div",attrs:{"fluid":""}},[_c('v-row',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"hidden-sm-and-down"},[_c('BenefitsWeb')],1),_c('div',{staticClass:"hidden-md-and-up"},[_c('BenefitsMobile')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }